var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12.3615 3 16.5797 4.00621 19.9132 6.32422C19.9676 6.36328 20 6.42735 20 6.49531C19.9577 17.7132 12.7069 21 12 21C11.293 20.9999 4.04224 17.7132 4 6.49531C4 6.42734 4.03244 6.36328 4.08675 6.32422C7.42029 4.00625 11.6385 3 12 3ZM12 21V3",
    stroke: "#5D697C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.5b3b37dba580618bf82def82fd8affb3.svg";
export { ForwardRef as ReactComponent };